import loanStore from "mobx/LoanStore"
import { toast } from "react-hot-toast"
import { BASE_URL } from "services"
import http from "./httpService"
import authStore from "mobx/AuthStore"
import apiRoute from "routes/apirRoutes"

export async function getAllBanks(payload) {
	try {
		const { data } = await http.get(apiRoute.banks, payload)
		toast.success(data.message)
		// authStore.resending_otp()
		// authStore.setCurrentStep("verify")
		// console.log("Helll Data email", data)

		return data
	} catch (err) {
		if (err && err.response) {
			// authStore.resending_otp()
			err?.response?.data?.error && toast.error(err.response.data.message)
			// console.log("Helll", err.response.data)
		} else {
			// authStore.resending_otp()
			toast.error("Network Error")
		}
	}
}

export async function resolveBank(payload) {
	try {
		const { data } = await http.post(apiRoute.resolveBank, payload)
		toast.success(data.message)
		return data
	} catch (err) {
		if (err && err.response) {
			err?.response?.data?.error && toast.error(err.response.data.message)
		} else {
			toast.error(err)
		}
	}
}

export async function resolveBVN(payload) {
	loanStore.loading()
	try {
		const { data } = await http.post(`${BASE_URL}/misc/kyc/bvn`, payload)
		toast.success(data.message)
		loanStore.loading()

		return data
	} catch (err) {
		loanStore.loading()
		if (err && err.response) {
			err?.response?.data?.error && toast.error(err.response.data.message)
		} else {
			toast.error("Network Error")
		}
	}
}
export async function miscUplaod(payload) {
	try {
		const { data } = await http.post(`${BASE_URL}/misc/upload`, payload)
		toast.success(data.message)
		return data
	} catch (err) {
		if (err && err.response) {
			// authStore.resending_otp()
			err?.response?.data?.error && toast.error(err.response.data.message)
			// console.log("Helll", err.response.data)
			return err?.response?.data
		} else {
			// authStore.resending_otp()
			toast.error("Network Error")
			return err
		}
	}
}

export async function sendContactMessage(payload) {
	authStore.sendMessage()
	try {
		const { data } = await http.post(`${BASE_URL}/messages/enquiry`, payload)
		toast.success(data.message)
		authStore.sendMessage()
		return data
	} catch (err) {
		authStore.sendMessage()
		if (err && err.response) {
			err?.response?.data?.error && toast.error(err.response.data.message)
			return err?.response?.data
		} else {
			toast.error("Network Error")
			return err
		}
	}
}

export async function subscribeToNewsLetter(payload) {
	authStore.loading()
	try {
		const { data } = await http.post(`${BASE_URL}/newsletter/subscribe`, payload)
		toast.success(data.message)
		authStore.loading()
		return data
	} catch (err) {
		authStore.loading()
		if (err && err.response) {
			err?.response?.data?.error && toast.error(err.response.data.message)
			return err?.response?.data
		} else {
			toast.error("Network Error")
			return err
		}
	}
}

export async function checkPortalStatus() {
	try {
	  const { data } = await http.get(`${BASE_URL}/misc/portal-status`);
	  if(data.data.loanPortal.toLowerCase() === "close"){
		toast.error("Portal is close");
		return {error: true, message:`Portal is ${data.data.loanPortal}`}
	  }
	  return data
	} catch (err) {
		if (err && err.response) {
			// err?.response?.data?.error && toast.error(err.response.data.message)
			return err?.response?.data
		} else {
			toast.error("Network Error")
			return err
		}
	}
}
export async function isRe_apply(type) {
	try {
		const { data } = await http.post(`${BASE_URL}/loans/re-apply`, {type});
		return data
	} catch (err) {
		if (err.response) {
			err?.response?.data?.error && toast.error(err.response.data.message)
			return err?.response?.data
		} else {
			toast.error("Network Error")
			return err
		}
	}
  }
export async function checkprofilestatus() {
	try {
		const { data } = await http.get(`${BASE_URL}/loans/check/profile`);
		return data
	} catch (err) {
		if (err.response) {
			err?.response?.data?.error && toast.error(err.response.data.message)
			return err?.response?.data
		} else {
			toast.error("Network Error")
			return err
		}
	}
  }
export async function checkOnBoarding() {
	try {
		const { data } = await http.get(apiRoute.onBoarding);
		const { onBoarded, nextStep} = data.data;
		return {onBoarded, nextStep, data:data.data}
	} catch (err) {
		if (err.response) {
			err?.response?.error && toast.error(err.response.msg)
			return err?.response?.error
		} else {
			return err
		}
	}
}

export const buildQuery = (params) => {

	if (!params) return ""

	const query = Object.entries(params)
		.filter(([_, value]) => value !== undefined && value !== null)
		.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
		.join("&");

	return query ? `?${query}` : "";
};

export async function getHomeAnalytics() {
	try {
		const { data } = await http.get(`${BASE_URL}/analytics`,);
		return data
	} catch (err) {
		if (err.response) {
			return err?.response?.data
		}
		return{
			status:"failed",
			message:"An error occurred could not get data"
		}
	}
}
export async function getAnalyticsLoans(queryObject) {
	const query = buildQuery(queryObject);
	try {
		const { data } = await http.get(`${BASE_URL}/analytics/loans${query}`,);
		return data
	} catch (err) {
		if (err.response) {
			return err?.response?.data
		}
		return{
			status:"failed",
			message:"An error occurred could not get data"
		}
	}
}
